import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";
import DemoForm from "../components/forms/Form";
import FormMini from "../components/forms/FormMini";
import Slideshow from "../components/Slideshow";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";
import ExitModal from "../components/ExitModal";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>Solidify Your Client Base With Our Repeat &amp; Referral Solution - Elm Street Technology</title>
        <meta
          name="description"
          content="Real estate is all about relationships. Nurturing them. Growing them. Building a close network of repeat business and referrals because of them."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/repeat-and-referral" />
        <meta property="og:title" content="Solidify Your Client Base With Our Repeat &amp; Referral Solution - Elm Street Technology" />
        <meta
          property="og:description"
          content="Real estate is all about relationships. Nurturing them. Growing them. Building a close network of repeat business and referrals because of them."
        />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />




 







      <div
        style={{
          backgroundImage: "url('rrbg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
        alt="Elm Street Technology Repeat and Referral"
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={5} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  height: "650px",
                }}
              >
                <div>
                  <Typography variant="h2" component="h1">
                    <span style={{ color: mainTheme.palette.secondary.main }}>Solidify Your Client Base</span> <br />
                    With Our<br />
                    Repeat &amp; Referral Solution
                  </Typography>
                  <p>
                  Real estate is all about relationships. Nurturing them. Growing them. Building a close network of repeat business and referrals because of them. We help you do that.
                    <br />
                    <br />
                    <Button variant="contained" color="secondary" href="#form">
                      schedule your tour
                    </Button>
                  </p>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>






      <div>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "35px",
            paddingBottom: "75px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h3">
                  <span style={{ color: "#f69c26" }}>
                  Our repeat &amp; referral
                    <br />
                  </span>{" "}
                  business solution lets you:
                </Typography>
                <br />
                <span>
                • Create a strong professional brand image that helps you stand out from the competition with a customizable business website.
                <br /><br />
                • Make generating referrals easier through automated outreach to past clients through text, direct mail, and email.
<br /><br />
• Manage all of your marketing outreach efforts, like publishing blog posts, sharing industry insights on social media, and sending branded mail to stay top of mind.
<br /><br />
• Deliver an exceptional customer experience, with a CRM that keeps your contacts, communications, and business organized.

                </span>
              </Grid>
              <Grid item md={6} sm={12} style={{ paddingBottom: "15px" }}>
                <div>
                  <Image
                    src="/rr1.png"
                    width="1000px"
                    height="1000px"
                    alt="Elm Street Technology - Repeat and Referral Business Solutions"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>





      <div
        style={{
          backgroundImage: "url('horizonbg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "30px",
            paddingRight: "30px",
            paddingTop: "20px",
          }}
        >
          <div style={{ marginTop: "55px", paddingBottom:"55px" }}>
            <Grid container spacing={12}>
              <Grid item md={12} sm={12} style={{ paddingBottom: "20px", textAlign:"center" }}>
                <span style={{ color: "#ffffff" }}>
                “I get 85% of my business from the Client Referrals System. This year alone, it has generated for me 35 transactions,
                in just 6 months...Get the Client Referrals System today. It's the easiest marketing decision you can make,
                above and beyond anything else.”<br />
                <strong style={{color:"#f69c26"}}>- Bill Parnaby</strong>
                </span>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>







      <div>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop:"75px",
          }}
        >
          <div style={{ marginTop: "15px" }}>
            <Grid container spacing={8}>
          
              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h3">
                  <span style={{ color: "#f69c26" }}>beautiful customizable </span><br />
                  IDX websites
                </Typography>
                <br />
                <span>
                Take control of your online business with a gorgeous website that is branded to you! Elm Street Repeat &amp; Referral makes customizing your real estate website easy and enjoyable. With unlimited customizable landing pages that look amazing on any screen, and intuitive analytics at your fingertips, you will have everything you need to run a modern and professional real estate site that your clients will actually use.
                </span>
                <br />
                <br />
                <Button variant="contained" color="secondary" href="#form">
                      let's get started!
                    </Button>
              </Grid>


              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <div>
                  <Image
                    src="/rrwebsites.png"
                    width="1080px"
                    height="1066px"
                    alt="Elm Street Technology Repeat and Referral - Beautiful Websites"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>








      <div>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingBottom: "75px",
          }}
        >
          <div style={{ marginTop: "85px" }}>
            <Grid container spacing={8}>
              <Grid item md={6} sm={12}>
                <div>
                  <Image
                    src="/rr2.png"
                    width="1000px"
                    height="1000px"
                    alt="Elm Street Technology Repeat and Referral - Multi-Touch Marketing"
                  />
                </div>
              </Grid>
              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h3">
                  <span style={{ color: "#f69c26" }}>multi-touch</span><br />
                  marketing
                </Typography>
                <br />
                <span>
                Set up and send email drip campaigns, newsletters, direct mail and text messages to your database with the Elm Street Repeat &amp; Referral automation services. Keep the connections in your sphere alive and get in front of your contacts with valuable content. Curious about your marketing performance? Check it out on your Email Reporting Dashboard.
                </span>
              
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>






      <div>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingBottom: "75px",
          }}
        >
          <div style={{ marginTop: "15px" }}>
            <Grid container spacing={8}>
          
              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h3">
                  <span style={{ color: "#f69c26" }}>social media</span><br />
                  marketing
                </Typography>
                <br />
                <span>
                Need help with social media? We provide industry-relevant curated content for you, and share it on your social channels to help keep you top of mind with your clients. Strategy, content creation, and social posting are all handled by our team, giving you more time back in your day. 
                </span>
                <br />
                <br />
                <Button variant="contained" color="secondary" href="#form">
                      explore our solution
                    </Button>
              </Grid>


              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <div>
                  <Image
                    src="/socialmedia2.png"
                    width="1000px"
                    height="947px"
                    alt="Elm Street Technology Repeat and Referral - Automated Social Media Marketing"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>






      <div>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingBottom: "75px",
          }}
        >
          <div>
            <Grid container spacing={8}>
              <Grid item md={6} sm={12}>
                <div>
                  <Image
                    src="/rr3.png"
                    width="1000px"
                    height="1000px"
                    alt="Elm Street Technology Repeat and Referral - Intuitive CRM"
                  />
                </div>
              </Grid>
              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h3">
                  <span style={{ color: "#f69c26" }}>intuitive </span>
                  crm
                </Typography>
                <br />
                <span>
                A CRM is essential in the real estate business. With the Elm Street Technology CRM as part of your system, you can keep your clients and business on track. Manage your contacts and marketing in just a few clicks or taps.
                
                </span>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>










      <div
        style={{
          backgroundImage: "url('horizonbg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "20px",
          }}
        >
          <div style={{ marginTop: "55px", paddingBottom:"55px" }}>
            <Grid container spacing={12}>
              <Grid item md={12} sm={12} style={{ paddingBottom: "20px", textAlign:"center" }}>
                <span style={{ color: "#ffffff" }}>
                “The Real Estate Marketing Success Systems will help you build lasting relationships with clients, hot prospects and your referral sources, almost effortlessly. I strongly endorse these systems and encourage you to try them. I believe so strongly in the positive impact these systems can have, they are an integral component of my Real Estate Training program.”<br />
                <strong style={{color:"#f69c26"}}>- Richard Robbins</strong>
                </span>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>















      <div
        style={{
          backgroundColor: "#ffffff",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "105px",
            paddingBottom: "65px",
          }}
        >
          <Grid container columnSpacing={16}>

          <Grid item md={4} sm={12} style={{ paddingBottom: "24px", textAlign:"center" }}>
              <span>
              <div style={{paddingBottom:"16px"}}>
                  <Image
                    src="/responsive_icon.svg"
                    width="140px"
                    height="140px"
                    alt="Lead-Generating IDX Websites"
                  />
                </div>
                <Typography variant="h4" component="h4" style={{paddingBottom:"16px"}}>
                lead<br />
                generating<br />
                <span style={{ color: "#f69c26" }}>idx websites
                  </span>
                </Typography>
                Capture more leads with fewer steps with our mobile-friendly and customizable websites. Enjoy effortless and pleasant website design with unlimited landing pages, automated client testimonial tools, and a drag-and-drop designer.
              </span>
            </Grid>

            <Grid item md={4} sm={12} style={{ paddingBottom: "24px", textAlign:"center" }}>
              <span>
              <div style={{paddingBottom:"16px"}}>
                  <Image
                    src="/coaching_icon.svg"
                    width="140px"
                    height="140px"
                    paddingBottom="16px"
                    alt="Automated Lead Nurture &amp; Workflows"
                  />
                </div>
                <Typography variant="h4" component="h4" style={{paddingBottom:"16px"}}>
                automated <span style={{ color: "#f69c26" }}><br />
                lead nurture<br />
                &amp; workflows
                  </span>
                </Typography>
                Keeping in touch while managing your business is time consuming. Gain back control of your time and keep the conversations going with a tool that nurtures relationships based on your last interaction. Send the right message at the right time to keep you top of mind with your sphere.
              </span>
            </Grid>

            <Grid item md={4} sm={12} style={{ paddingBottom: "24px", textAlign:"center" }}>
              <span>
              <div style={{paddingBottom:"16px"}}>
                  <Image
                    src="/retention_icon.svg"
                    width="140px"
                    height="140px"
                    paddingBottom="16px"
                    alt="Repeat &amp; Referral Marketing From Anywhere"
                  />
                </div>
                <Typography variant="h4" component="h4" style={{paddingBottom:"16px"}}>
                Repeat &amp; Referral<br />
                <span style={{ color: "#f69c26" }}> Marketing From Anywhere
                  </span>
                </Typography>
                Whether you use a computer, tablet, or smartphone, you have access to it anywhere you are. Respond to leads, keep in touch with key contacts, and stay on top of all your tasks and appointments without
                <br />missing a beat.
              </span>
            </Grid>
           
          </Grid>
        </Container>
      </div>





      <div>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingBottom: "85px",
          }}
        >
          <div style={{ marginTop: "35px" }}>
            <Grid container spacing={8}>
         
              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4">
                emphatic<br />
                <span style={{ color: "#f69c26" }}>customer<br />
                    support &amp; training
                  </span>
                </Typography>

                <p>
                People are the key to the success of any technology and its adoption. Our team of reliable experts deliver a smooth support experience and continued training, whenever you need it.
                </p>
                
                
                <Button variant="contained" color="secondary" href="#form">
                      schedule a demo
                    </Button>
                
              </Grid>
              <Grid item md={6} sm={12}>
                <div>
                  <Image
                    src="/agents5.png"
                    width="1080px"
                    height="1066px"
                    alt="Elm Street Technology - Emphatic Training &amp; Support"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>






      <div
        style={{
          backgroundImage: "url('esbg3.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "25px",
          }}
        >
          <div style={{ marginTop: "35px" }}>
            <Slideshow
              pages={[
                <Grid container spacing={8} key="1">
                  <Grid item md={4} sm={12} style={{ paddingBottom: "36px", whiteSpace: "normal" }}>
                    <Typography variant="h4" component="h4" style={{ color: "#ffffff" }}>
                      <span style={{ color: "#f69c26" }}>
                        Easy-To-Use</span>{" "}<br />
                        dashbroard &amp; metrics
                    </Typography>
                    <br />
                    <span style={{ color: "#ffffff" }}>
                    Keep track of what matters to your business with daily, at-a-glance information.

                    </span>
                  </Grid>
                  <Grid item md={8} sm={12} style={{ marginBottom: "-6px" }}>
                    <div>
                      <Image
                        src="/rrs1.png"
                        width="1080px"
                        height="717px"
                        alt="Elm Street Technology - Intuitive CRM"
                      />
                    </div>
                  </Grid>
                </Grid>,

                <Grid container spacing={8} key="2">
                  <Grid item md={4} sm={12} style={{ paddingBottom: "36px", whiteSpace: "normal" }}>
                    <Typography variant="h4" component="h4" style={{ color: "#ffffff" }}>
                      <span style={{ color: "#f69c26" }}>
                        IDX
                        <br />
                      </span>{" "}
                      websites
                    </Typography>
                    <br />
                    <span style={{ color: "#ffffff" }}>
                    SEO-friendly websites reflect you and your brand, with built-in lead capture, mobile-friendly layout, and beautiful designs.

                    </span>
                  </Grid>
                  <Grid item md={8} sm={12} style={{ marginBottom: "-6px" }}>
                    <div>
                      <Image
                        src="/crm2.png"
                        width="1080px"
                        height="717px"
                        alt="Elm Street Technology - IDX Websites"
                      />
                    </div>
                  </Grid>
                </Grid>,

                <Grid container spacing={8} key="3">
                  <Grid item md={4} sm={12} style={{ paddingBottom: "36px", whiteSpace: "normal" }}>
                    <Typography variant="h4" component="h4" style={{ color: "#ffffff" }}>
                      <span style={{ color: "#f69c26" }}>
                        marketing
                        <br />
                      </span>{" "}
                      automation
                    </Typography>
                    <br />
                    <span style={{ color: "#ffffff" }}>
                    Put your day-to-day tasks and content on auto-pilot, so you have more time for what's important.

                    </span>
                  </Grid>
                  <Grid item md={8} sm={12} style={{ marginBottom: "-6px" }}>
                    <div>
                      <Image
                        src="/rrn1.png"
                        width="1080px"
                        height="717px"
                        alt="Elm Street Technology - Marketing Automation"
                      />
                    </div>
                  </Grid>
                </Grid>,

                <Grid container spacing={8} key="4">
                  <Grid item md={4} sm={12} style={{ paddingBottom: "20px", whiteSpace: "normal" }}>
                    <Typography variant="h4" component="h4" style={{ color: "#ffffff" }}>
                      <span style={{ color: "#f69c26" }}>
                        repeat &amp; referral
                        <br />
                      </span>{" "}
                     marketing
                    </Typography>
                    <br />
                    <span style={{ color: "#ffffff" }}>
                    Increase referrals, repeat business, and lead conversions with a client referral program that is designed to work for you.
                    </span>
                  </Grid>
                  <Grid item md={8} sm={12} style={{ marginBottom: "-6px" }}>
                    <div>
                      <Image
                        src="/rrs4.png"
                        width="1080px"
                        height="717px"
                        alt="Elm Street Technology - Repeat &amp; Referral Marketing"
                      />
                    </div>
                  </Grid>
                </Grid>,

                <Grid container spacing={8} key="5">
                  <Grid item md={4} sm={12} style={{ paddingBottom: "20px", whiteSpace: "normal" }}>
                    <Typography variant="h4" component="h4" style={{ color: "#ffffff" }}>
                      <span style={{ color: "#f69c26" }}>
                        intuitive
                        <br />
                      </span>{" "}
                      CRM
                    </Typography>
                    <br />
                    <span style={{ color: "#ffffff" }}>
                    Never miss another opportunity when your leads, communication and follow-up all live in one location.
                    </span>
                  </Grid>
                  <Grid item md={8} sm={12} style={{ marginBottom: "-6px" }}>
                    <div>
                      <Image
                        src="/rrn2.png"
                        width="1080px"
                        height="717px"
                        alt="Elm Street Technology - Intuitive CRM"
                      />
                    </div>
                  </Grid>
                </Grid>,
              ]}
              showDots={false}
            />
          </div>
        </Container>
      </div>









      <div
        style={{
          backgroundImage: "url('orangebg.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg" style={{ paddingTop: "80px", paddingBottom: "85px" }}>
          <div style={{}}>
            <a id="form" />
            <Typography variant="h4" component="h4" style={{ color: "#1d1746", textAlign: "center" }}>
              schedule your tour today!
            </Typography>
            <div style={{ paddingBottom: "40px", paddingLeft:"20px", paddingRight:"20px", textAlign: "center" }}>
              <strong style={{ color: "#1d1746", textAlign: "center" }}>
                Connect with an Elm Street Technology<br />
                Success Coach to Prospect Leads &amp; Clients More Easily.
              </strong>
            </div>
            <div style={{ padding: "15px", backgroundColor: "#ffffff" }}>
              <Container
                maxWidth="lg"
                style={{
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  marginTop: "65px",
                  marginBottom: "65px",
                }}
              >
                <Grid container>
                  <Grid item md={2} sm={12} xs={12} />
                  <Grid item md={8} sm={12} xs={12}>
                    <DemoForm
                      buttonText="Schedule Demo"
                      successUrl="thankyou"
                      listId="147986"
                      formName="es2_repeatReferral"
                      fieldList={["first_name", "last_name", "email", "phone", "roll", "markets"]}
                    />
                  </Grid>
                </Grid>
              </Container>
            </div>
          </div>
        </Container>
      </div>

      <MainFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
